export const iconFontAwesomeMediaplaybackSliders = (
	<i className="fa-solid fa-sliders"></i>
);
